// Angular
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
// NGRX
import { Store } from '@ngrx/store';
// RxJS
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

// Layout
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
// Auth
import { AuthService } from '../../../../../../core/auth';
// State
import { AppState } from '../../../../../../core/reducers';

@Component({
  selector: 'kt-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyComponent implements OnInit {
  @Input() companySubject: BehaviorSubject<any>;
  hasFormErrors = false;
  companyForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private auth: AuthService,
    private store: Store<AppState>,
    private layoutUtilsService: LayoutUtilsService
  ) {}

  ngOnInit() {
    if (!this.companySubject.value) {
      this.companySubject.next({
        companyName: '',
        companyVat: '',
        companyFiscalService: '',
        companyAddress: '',
        companyCity: '',
        companyPostCode: '',
      });
    }

    this.createForm();
    this.companyForm.valueChanges
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => this.updateCompany())
      )
      .subscribe();
  }

  createForm() {
    this.companyForm = this.fb.group({
      companyName: [this.companySubject.value.companyName],
      companyVat: [this.companySubject.value.companyVat],
      companyFiscalService: [this.companySubject.value.companyFiscalService],
      companyAddress: [this.companySubject.value.companyAddress],
      companyCity: [this.companySubject.value.companyCity],
      companyPostCode: [this.companySubject.value.companyPostCode],
    });
  }

  updateCompany() {
    this.hasFormErrors = false;
    const controls = this.companyForm.controls;
    /** check form */
    if (this.companyForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      this.hasFormErrors = true;

      return;
    }

    this.companySubject.next({
      companyName: controls.companyName.value,
      companyVat: controls.companyVat.value,
      companyFiscalService: controls.companyFiscalService.value,
      companyAddress: controls.companyAddress.value,
      companyCity: controls.companyCity.value,
      companyPostCode: controls.companyPostCode.value,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onAlertClose($event) {
    this.hasFormErrors = false;
  }
}
